import { Component } from '@angular/core';
import { IonicPage, NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the ActivepopupPage page.
 *
 * 로그인 후 대시보드에서 뜨는 Active 안내 팝업 (2026-08-26 PDF p.5·p.7~9).
 * 두 가지 모양을 한 페이지가 겸한다 - navParams `mode` 로 구분:
 *   'apply' : Active 신청이 최초인 경우 (선물상자 이미지 + 프로모 문구 + "지금 신청하기")
 *   'renew' : Active 를 유지할 입금이 없는 경우 (쇼핑백 이미지 + 갱신실패 문구 + "지금 입금하기")
 *
 * dismiss 값: { action: 'cta' | 'close', hideToday: boolean }
 * - 'cta' 를 받은 쪽(wallet.ts)이 신청 확인 모달로 갈지 입금 팝업으로 갈지 결정한다.
 * - hideToday 는 "오늘 하루 보지 않기" 체크 여부. 저장은 호출한 쪽이 한다.
 */

@IonicPage()
@Component({
    selector: 'page-activepopup',
    templateUrl: 'activepopup.html',
})
export class ActivepopupPage {

    // 'apply' | 'renew'
    mode: string = 'apply';

    texts: any = {};
    language: string;

    hideToday: boolean = false;

    constructor(
        public navParams: NavParams,
        public viewCtrl: ViewController
    ) {
        this.mode = navParams.get('mode') || 'apply';
    }

    ionViewWillEnter() {
        this.language = localStorage.getItem("language");
        this._get_texts();
    }

    _get_texts() {
        // PDF p.6 언어팩 스펙 - 기존 'active' 섹션과 별도 섹션이다
        // ('active' 쪽에도 비슷한 이름의 키가 있지만 값이 "Active Details" 라 다른 용도).
        this.texts = JSON.parse(localStorage.getItem('lang_pack')).active_apply_popup || {};
    }

    get title(): string {
        return this.texts.active_apply_popup_title || 'Active Membership';
    }

    get image(): string {
        return (this.mode == 'renew')
            ? 'assets/imgs/active_popup_renew.png'
            : 'assets/imgs/active_popup_apply.png';
    }

    get message(): string {
        if (this.mode == 'renew') {
            return this.texts.payment_urge_text
                || 'Active 멤버십의 이번 달 자동 갱신이 정상적으로 처리되지 않았습니다.';
        }
        return this.texts.active_promo_text
            || '지금 Active를 활성화하고, 오직 멤버십 회원에게만 제공되는 특별한 프리미엄 특전을 즉시 만나보세요.';
    }

    get ctaLabel(): string {
        return (this.mode == 'renew')
            ? (this.texts.btn_deposit_now || '지금 입금하기')
            : (this.texts.btn_apply_now || '지금 신청하기');
    }

    _toggle_today() {
        this.hideToday = !this.hideToday;
    }

    _cta() {
        this.viewCtrl.dismiss({ action: 'cta', hideToday: this.hideToday });
    }

    _close() {
        this.viewCtrl.dismiss({ action: 'close', hideToday: this.hideToday });
    }
}



// WEBPACK FOOTER //
// ./src/pages/activepopup/activepopup.ts